import Http from '../utils/http';

export default class GameApiService {
  /**
   * Načíta zo servera štatictické vyhodnotenie predchádzajúceho kola
   *
   * @param {number} gameId Identifikátor hry
   * @returns Vyhodnotenie kola
   */
    static async getPreviousRoundResults(gameId) {
        const { data } = await Http.get(`/api/games/${gameId}/prev-round-results`);
        return data;
    }

    static startNextRound(gameId) {
        return Http.post(`/api/games/${gameId}/start-next-round`);
    }
}
